import React, { useMemo } from "react";
import config from "../SupportFiles/config";

const ListChart = ({
  series = [],
  categories = [],
  options = {},
  height = "100%",
  width = "100%",
}) => {
  const values = useMemo(() => {
    if (Array.isArray(series) && typeof series[0] === "number") return series;
    if (Array.isArray(series) && Array.isArray(series[0]?.data))
      return series[0].data;
    return [];
  }, [series]);
  const labels = useMemo(() => {
    if (Array.isArray(categories) && categories.length === values.length)
      return categories;
    return values.map((_, i) => `Item ${i + 1}`);
  }, [categories, values]);
  const colors = options.colors || config.colors;
  const valueColor = options.list?.valueColor || "#FE9855";
  const borderColor = options.list?.borderColor || "#e5e7eb";
  const rounded = options.list?.rounded ?? 8;
  const itemPadding = options.list?.item?.padding ?? 10;
  const itemGap = options.list?.item?.gap ?? 8;
  const showColorDot = options.list?.showColorDot ?? false;
  const showTotal = options.list?.total ?? false;
  const totalLabel = options.list?.totalLabel ?? "Total";
  const sum = useMemo(
    () => values.reduce((a, v) => a + (typeof v === "number" ? v : 0), 0),
    [values]
  );
  const format = (v) => {
    try {
      return new Intl.NumberFormat("en-US").format(v);
    } catch {
      return String(v);
    }
  };
  return (
    <div style={{ width, height, position: "relative" }}>
      <div className="h-full flex flex-col gap-5 ">
        <div className="flex-1 flex flex-col gap-2 overflow-auto">
          {labels.map((lab, i) => (
            <div
              key={`list-${i}`}
              className="flex items-center justify-between p-2 px-4 border border-gray-200 rounded-md bg-white"
            >
              <span className="font-medium">{lab}</span>
              <span className={`text-red-500 font-medium`}>
                {format(values[i] ?? 0)}
              </span>
            </div>
          ))}
        </div>
        {showTotal && (
          <div className="flex items-center justify-between p-2 px-4 border border-primary-100 rounded-md bg-primary-400 text-white">
            <span>{totalLabel}</span>
            <span>{format(sum)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListChart;
